<template>
  <div>
    <div class="row">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <div class="card" style="border-radius: 12px">
          <ul
            class="nav nav-pills"
            id="pills-tab"
            role="tablist"
            style="border-radius: 12px"
          >
            <li class="nav-item" role="presentation">
              <button
                class="nav-link2"
                :class="$route.path.includes('resumen') ? 'active' : ''"
                type="button"
                role="tab"
                @click="$router.push('/administracion/resumen')"
              >
                <i
                  style="font-size: 14px; margin-right: 5px"
                  class="fa fa-chart-simple text-success"
                ></i>
                Resumen
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button
                class="nav-link2"
                :class="$route.path.includes('ventas') ? 'active' : ''"
                type="button"
                role="tab"
                @click="$router.push('/administracion/ventas')"
              >
                <i
                  style="font-size: 14px; margin-right: 5px"
                  class="fa fa-shopping-cart text-success"
                ></i>
                Ventas
              </button>
            </li>
            <li
              class="nav-item"
              role="presentation"
              v-show="userRole === 'admin'"
            >
              <button
                class="nav-link2"
                :class="$route.path.includes('retiros') ? 'active' : ''"
                type="button"
                role="tab"
                @click="$router.push('/administracion/retiros')"
              >
                <i
                  style="font-size: 14px; margin-right: 5px"
                  class="fa fa-money-bill text-success"
                ></i>
                Retiros
              </button>
            </li>

            <li class="nav-item" role="presentation">
              <button
                class="nav-link2"
                :class="$route.path.includes('instaladas') ? 'active' : ''"
                type="button"
                role="tab"
                @click="$router.push('/administracion/instaladas')"
              >
                <i
                  style="font-size: 14px; margin-right: 5px"
                  class="fa fa-money-bill text-success"
                ></i>
                Ventas Instaladas
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button
                class="nav-link2"
                :class="$route.path.includes('transacciones') ? 'active' : ''"
                type="button"
                role="tab"
                @click="$router.push('/administracion/transacciones')"
              >
                <i
                  style="font-size: 14px; margin-right: 5px"
                  class="fa fa-receipt text-success"
                ></i>
                Transacciones
              </button>
            </li>
            <li
              class="nav-item"
              role="presentation"
              v-show="userRole === 'admin'"
            >
              <button
                class="nav-link2"
                :class="$route.path.includes('recursos') ? 'active' : ''"
                type="button"
                role="tab"
                @click="$router.push('/administracion/recursos')"
              >
                <i
                  style="font-size: 14px; margin-right: 5px"
                  class="fa fa-folder-tree text-success"
                ></i>
                Recursos
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button
                class="nav-link2"
                :class="$route.path.includes('usuarios') ? 'active' : ''"
                type="button"
                role="tab"
                @click="$router.push('/administracion/usuarios')"
              >
                <i
                  style="font-size: 14px; margin-right: 5px"
                  class="fa fa-users text-success"
                ></i>
                Usuarios
              </button>
            </li>
            <li
              class="nav-item"
              role="presentation"
              v-show="userRole === 'admin'"
            >
              <button
                class="nav-link2"
                :class="$route.path.includes('promociones') ? 'active' : ''"
                type="button"
                role="tab"
                @click="$router.push('/administracion/promociones')"
              >
                <i
                  style="font-size: 14px; margin-right: 5px"
                  class="fa fa-gift text-success"
                ></i>
                Promociones
              </button>
            </li>
            <li
              v-if="userRole === 'admin'"
              class="nav-item"
              role="presentation"
            >
              <button
                class="nav-link2"
                :class="$route.path.includes('bot') ? 'active' : ''"
                type="button"
                role="tab"
                @click="$router.push('/administracion/bot')"
              >
                <i
                  style="font-size: 14px; margin-right: 5px"
                  class="fa fa-robot text-success"
                ></i>
                Bot
              </button>
            </li>
            <li
              class="nav-item"
              role="presentation"
              v-show="userRole === 'admin'"
            >
              <button
                class="nav-link2"
                :class="
                  $route.path === '/administracion/mailing' ? 'active' : ''
                "
                type="button"
                role="tab"
                @click="$router.push('/administracion/mailing')"
              >
                <i
                  style="font-size: 14px; margin-right: 5px"
                  class="fa fa-envelope text-success"
                ></i>
                Mailing (pruebas)
              </button>
            </li>
            <li
              class="nav-item"
              role="presentation"
              v-show="userRole === 'admin'"
            >
              <button
                class="nav-link2"
                :class="
                  $route.path.includes('mailing-campanas') ? 'active' : ''
                "
                type="button"
                role="tab"
                @click="$router.push('/administracion/mailing-campanas')"
              >
                <i
                  style="font-size: 14px; margin-right: 5px"
                  class="fa fa-paper-plane text-warning"
                ></i>
                Campañas
              </button>
            </li>
            <li
              class="nav-item"
              role="presentation"
              v-show="userRole === 'admin'"
            >
              <button
                class="nav-link2"
                :class="
                  $route.path.includes('whatsapp-campanas') ? 'active' : ''
                "
                type="button"
                role="tab"
                @click="$router.push('/administracion/whatsapp-campanas')"
              >
                <i
                  style="font-size: 14px; margin-right: 5px"
                  class="fa fa-whatsapp text-success"
                ></i>
                Campañas WhatsApp
              </button>
            </li>
            <li
              class="nav-item"
              role="presentation"
              v-show="userRole === 'admin'"
            >
              <button
                class="nav-link2"
                :class="$route.path.includes('simulador') ? 'active' : ''"
                type="button"
                role="tab"
                @click="$router.push('/administracion/simulador')"
              >
                <i
                  style="font-size: 14px; margin-right: 5px"
                  class="fa fa-flask text-success"
                ></i>
                Simulador
              </button>
            </li>
          </ul>
        </div>
      </div>

      <div
        class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
        style="margin-top: 15px"
      >
        <router-view
          :user-id="userId"
          :token-auth="tokenAuth"
          :role="role"
          :user-role="userRole"
        />
      </div>
    </div>
  </div>
</template>

<script>
/*eslint-disable */
import "bootstrap"; //no eliminar, este le da el evento al nav pills

export default {
  data() {
    let datos = this.$store.state.user;

    return {
      isMobile: this.$isMobile,
      userId: datos.userId,
      tokenAuth: this.$store.state.tokenAuth,
      role: datos.role,
      userRole: this.$store.state.userRole || "",
    };
  },
  activated() {
    if (this.isMobile) {
      this.$eventBus.emit("inactiveShowMenu");
    }
  },
  mounted() {
    document.title = "XTRIMPRO - Administración";
    if (this.$store.state.userRole) {
      this.userRole = this.$store.state.userRole;
    } else {
      this.getAccess();
    }
  },
  methods: {
    getAccess() {
      this.$https
        .post("/auth/accessAdminPanel")
        .then((response) => {
          this.userRole = response.data.role;
          this.$store.commit("SET_USER_ROLE", response.data.role);
        })
        .catch((error) => {
          console.log("Error:", error);
        });
    },
  },
};
</script>

<style lang="scss">
@import "./components/AdminDataTables.scss";
</style>
